export const GENERATE_API_KEY_ACTION="GENERATE_API_KEY_ACTION"
export const GET_API_KEY_ACTION="GET_API_KEY_ACTION"